module.exports = __webpack_public_path__ + "img/zhu.c6d534df.jpg";